var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-scrollbar__wrap wrap-white padding-20" },
    [
      _c(
        "div",
        { staticClass: "el-scrollbar__view" },
        [
          _c(
            "el-form",
            {
              ref: "inputForm",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "发送到",
                            prop: "emailAddress",
                            rules: [
                              {
                                required: true,
                                message: "收件地址不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "输入多个邮件地址请用英文符号;隔开",
                            },
                            model: {
                              value: _vm.inputForm.emailAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "emailAddress", $$v)
                              },
                              expression: "inputForm.emailAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "10px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.doSubmit },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "标题",
                            prop: "title",
                            rules: [
                              {
                                required: true,
                                message: "标题不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入标题" },
                            model: {
                              value: _vm.inputForm.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "title", $$v)
                              },
                              expression: "inputForm.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "内容",
                            prop: "content",
                            rules: [
                              {
                                required: true,
                                message: "内容不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("WangeEditor", {
                            ref: "editor",
                            model: {
                              value: _vm.inputForm.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "content", $$v)
                              },
                              expression: "inputForm.content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }